import { useFormikContext } from "formik";
import React, { FunctionComponent } from "react";
import { getBouwsparenLimit } from "./bouwsparen";
import { HelpForm } from "./HelpForm";
import { getLangetermijnsparenLimit } from "./langetermijnsparen";
import { TaxCodeHelpDialog } from "./TaxCodeHelpDialog";

export interface Props {
  code: string;
  clearCode: () => void;
}

export const codesForSchuldSaldoVerzekeringBouwsparen = ["1351", "2351", "3351", "4351"];

export const HelpSchuldSaldoVerzekeringBouwsparen: FunctionComponent<Props> = ({ code, clearCode }) => {
  const {
    setFieldValue,
    values: { gewest },
  } = useFormikContext<any>();
  const handleSubmit = React.useCallback(
    (values) => {
      const {
        premie,
        verzekerdBedragAangever,
        verzekerdBedragPartner,
        bedragLening,
        jaarLening,
        KTLJaarNaLening,
      } = values;
      const limitBouwsparen = getBouwsparenLimit(jaarLening, KTLJaarNaLening);
      const limitLangetermijnsparen = getLangetermijnsparenLimit(jaarLening, gewest, code as string);
      const bouwSparen =
        (premie * Math.min(limitBouwsparen, verzekerdBedragAangever + verzekerdBedragPartner, bedragLening)) /
          (verzekerdBedragPartner + verzekerdBedragAangever) || 0;
      const langetermijnsparen = limitLangetermijnsparen ? premie - bouwSparen : 0;

      setFieldValue(`c${code}`, bouwSparen);
      setFieldValue(`c${parseInt(code as string, 10) + 2}`, langetermijnsparen);
      clearCode();
    },
    [code, gewest, setFieldValue, clearCode]
  );

  return (
    <TaxCodeHelpDialog code={code} onClose={clearCode} dialogForCodes={codesForSchuldSaldoVerzekeringBouwsparen}>
      <HelpForm
        fields={[
          "premie",
          "verzekerdBedragAangever",
          "verzekerdBedragPartner",
          "bedragLening",
          "jaarLening",
          "KTLJaarNaLening",
        ]}
        onSubmit={handleSubmit}
        code={code}
      />
    </TaxCodeHelpDialog>
  );
};

HelpSchuldSaldoVerzekeringBouwsparen.displayName = "HelpSchuldSaldoVerzekeringBouwsparen";
